import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import SEO from '../components/SEO';
import PublicNavHeader from '../components/PublicNavHeader';
import Footer from '../components/Footer';

import {
  ArrowRight,
  Globe,
  TrendUp,
  Trophy,
  UsersThree
} from '@phosphor-icons/react';
const PartnerProgram = () => {
  return (
    <>
      <SEO title="Partner Program - Man & Machine" description="Join the Man & Machine Partner Program. Build, deploy & scale AI solutions professionally." />
      <PublicNavHeader />
      
      <div className="min-h-screen bg-[#0a0a0f]">
        <section className="relative overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-br from-[#6366F1]/10 via-transparent to-[#EC4899]/10" />
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-[#6366F1]/20 blur-[120px] rounded-full" />
          
          <div className="relative max-w-7xl mx-auto px-6 py-20 lg:py-28">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              className="text-center max-w-3xl mx-auto"
            >
              <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#6366F1]/10 border border-[#6366F1]/20 text-[#6366F1] text-sm font-medium mb-6">
                <UsersThree size={16} />
                Partner Program
              </div>
              
              <h1 className="text-4xl sm:text-5xl font-bold text-white mb-6">
                Grow Your AI Practice with{' '}
                <span className="bg-gradient-to-r from-[#6366F1] to-[#EC4899] text-transparent bg-clip-text">
                  Man & Machine
                </span>
              </h1>
              
              <p className="text-lg text-[#A0AEC0] mb-8">
                Join a curated network of AI consultants, agencies, and automation professionals delivering real-world AI solutions.
              </p>

              <div className="flex flex-wrap gap-4 justify-center">
                <Link
                  to="/partners/apply"
                  className="inline-flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-[#6366F1] to-[#8B5CF6] text-white font-semibold rounded-full hover:opacity-90 transition-opacity"
                >
                  Apply Now
                  <ArrowRight size={18} />
                </Link>
                <Link
                  to="/partners"
                  className="inline-flex items-center gap-2 px-6 py-3 glass text-white font-semibold rounded-full hover:bg-[rgba(255,255,255,0.1)] transition-all"
                >
                  Find a Partner
                </Link>
              </div>
            </motion.div>
          </div>
        </section>

        <section className="max-w-7xl mx-auto px-6 pb-20">
          <h2 className="text-2xl font-bold text-white text-center mb-12">Partner Benefits</h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {[
              { icon: Trophy, title: 'Directory Listing', description: 'Get discovered by businesses seeking AI expertise.' },
              { icon: TrendUp, title: 'Scalable Delivery', description: 'Repeatable client work with our platform tools.' },
              { icon: Globe, title: 'Partner Pro Access', description: 'Exclusive features for professional delivery.' },
              { icon: UsersThree, title: 'Curated Network', description: 'Join a trusted community of AI professionals.' }
            ].map((item, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: i * 0.1 }}
                className="glass rounded-2xl p-6 text-center"
              >
                <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-[#6366F1] to-[#8B5CF6] flex items-center justify-center mx-auto mb-4">
                  <item.icon size={28} className="text-white" />
                </div>
                <h3 className="text-lg font-semibold text-white mb-2">{item.title}</h3>
                <p className="text-[#A0AEC0] text-sm">{item.description}</p>
              </motion.div>
            ))}
          </div>
        </section>
      </div>
      
      <Footer />
    </>
  );
};

export default PartnerProgram;